import React from "react";

import './social.css';
export default () => {

        return (
            <div className="socialBox" key="social">
                <div className="socialMessage">
                    Metti <b>"mi piace"</b> per essere sempre aggiornato sui nuovi articoli.
                </div>
            <iframe title="facebook-frame" src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fcrearemondi%2F&tabs=timeline&width=280&height=230&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId=283308832588276" width="280" height="230" style={{border:'none',overflow:'hidden'}} scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>

        </div>
        );
}